/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-11-25 16:11:05
 * @LastEditTime: 2022-03-08 12:01:35
 */
import http from '@/axios/http'

//设备组态根据设备Did查询监控大屏显示的变量列表
export function getParamsByDid(deviceDid,type,sid,current,size) {
  return http({
    url: '/api2/screen/variable/list',
    method: 'post',
    data: {
      deviceDid,
      sid,
      current,
      size,
      type
    }
  })
}
// 设备组态添加变量时，变量表格的变量列表
export function getDeviceParams(deviceDid) {
  return http({
    url: '/api2/variable/device/list',
    method: 'post',
    data: {
      deviceDid,
      type:"2"
    }
  })
}
//设备组态根据设备Did添加已有的变量到设备组态中
export function addParamsByDid(data) {
  return http({
    url: '/api2/screen/variable/add',
    method: 'post',
    data,
  })
}

//设备组态删除展示的变量
export function deleteParams(data) {
  return http({
    url: '/api2/screen/variable/del',
    method: 'post',
    data,
  })
}

// 修改设备组态的开关值
export function setModbusSwitch(data) {
  return http({
    url: '/api2/monitor/coil',
    method: 'post',
    data,
  })
}
// 修改设备组态的数据值
export function setModbusValue(data) {
  return http({
    url: '/api2/monitor/value',
    method: 'post',
    data,
  })
}
export function setIocontrolSwitch(data) {
  return http({
    url: '/api2/monitor/relay',
    method: 'post',
    data,
  })
}
